<a class="blog-teaser" [routerLink]="blogUrl()">
    <img class="mobile" [ngSrc]="blogImageUrl()" [width]="300" [height]="190" sizes="50vw" [title]="blogImageTitle()"
        [alt]="blogImageTitle()">
    <img class="desktop" [ngSrc]="blogImageUrl()" [width]="400" [height]="280" sizes="50vw" [title]="blogImageTitle()"
        [alt]="blogImageTitle()">
    <h2 class="blog-teaser__title">{{ blogTitle() }}</h2>
</a>